export const deepTrim = (data: unknown) => {
  switch (typeof data) {
    case 'string':
      return data.trim();
    case 'object':
      return trimObject(data);
    default:
      return data;
  }
};

export const trimObject = (data: object | null) => {
  if (!data) return null;

  if (data instanceof FormData) {
    return trimFormData(data);
  }

  if (Array.isArray(data)) {
    return trimArray(data);
  }

  const result: Record<string, unknown> = { ...data };
  Object.entries(data).forEach(([key, value]) => {
    result[key] = deepTrim(value);
  });
  return result;
};

export const trimFormData = (data: FormData) => {
  const result = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    result.set(key, typeof value === 'string' ? value.trim() : value);
  });
  return result;
};

export const trimArray = (data: Array<unknown>): Array<unknown> => {
  return data.map(value => deepTrim(value));
};
